import styles from '../../assets/css/accounts.module.css';
import NextButton from '../NextButton';
import StepHeader from '../StepHeader';
import AccountsList from './AccountsList';
import { useTranslation } from 'react-i18next';
import { ACCOUNT_SELECTION_PREFIX } from '../../utils/translationPagePrefix';
import useCustomization from '../../hooks/useCustomization';
import NoAccountsMessage from './NoAccountsMessage';
import { CustomizationKey } from '../../contexts/CustomizationsContext';
import { Account } from '../../types/account';

interface AccountSelectionProps {
	accounts: Array<Account>;
	selectedAccount: Account | null;
	bankName: string;
	bankCode: string;
	bankLogo?: string;
	onAccountSelect(account: Account): void;
	onContinue(): void;
}

const ACCOUNT_SELECTION_SUBTITLE_KEY: CustomizationKey = 'ACCOUNT_SELECTION_SUBTITLE';
const ACCOUNT_SELECTION_TITLE_KEY: CustomizationKey = 'ACCOUNT_SELECTION_TITLE';

const AccountSelection = ({
	accounts,
	onAccountSelect,
	bankLogo,
	selectedAccount,
	bankName,
	onContinue
}: AccountSelectionProps) => {
	const { t } = useTranslation();

	const subtitle = useCustomization(ACCOUNT_SELECTION_SUBTITLE_KEY);
	const title = useCustomization(ACCOUNT_SELECTION_TITLE_KEY);

	const continueText = t(`${ACCOUNT_SELECTION_PREFIX}.continue`);

	return (
		<div id="account-selection-step" className={styles['account-selection-container']}>
			<div className={styles['acc-selection-div-element']}>
				<StepHeader title={title} subtitle={subtitle} bankName={bankName} bankLogo={bankLogo} />
			</div>
			{accounts.length === 0 ? (
				<NoAccountsMessage />
			) : (
				<>
					<div className={styles['acc-selection-div-element']}>
						<AccountsList
							accounts={accounts}
							selectedAccount={selectedAccount}
							onAccountSelect={onAccountSelect}
						/>
					</div>
					<div className={styles['acc-selection-div-element']}>
						<div className={styles['button-container']}>
							<NextButton text={continueText} onClick={onContinue} disabled={!selectedAccount} />
						</div>
					</div>
				</>
			)}
		</div>
	);
};

export default AccountSelection;
